import EpiContext from '@episerver/spa-core/Spa';

export function checkLoginData(data) {
  return data.isOtpExtendedAuthenticated || data.isFullAuthenticated || data.isOtpAuthenticated || data.isSilentOtpAuthenticated;
}

export function getProductStatus(subscriber) {
  const ActiveStatus = ['Active', 'A', 'INS'];
  if (subscriber.isBusinness) {
    return 'עסקי';
  } else {
    if (!ActiveStatus.includes(subscriber.productStatus)) {
      return subscriber.productStatusDesc;
    }
  }
  return;
}

export function UpdateSubscriberName(selectedSubscriber, loginData, links) {
  if ((loginData.isOtpExtendedAuthenticated || loginData.isFullAuthenticated) && loginData?.userDetails?.contactNumber === selectedSubscriber.productSubscriberNo) {
    EpiContext.navigateTo(links.updateContactDetailsLink);
  } else {
    EpiContext.navigateTo(links.updateSubscriberNameLink);
  }
}
